import { jsx as _jsx } from "react/jsx-runtime";
export const Dot = ({ bgColorClassName, animating }) => {
    return (_jsx("span", { className: `size-2 rounded-full transition-colors duration-300 ${bgColorClassName}${animating ? " animate-pulse" : ""}` }));
};
